
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimulation as ObiSimulationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simulation.js';
 
 
 

 
 export const ObiSimulation = createComponent({
   react: React,
   tagName: 'obi-simulation',
   elementClass: ObiSimulationElement,
   events: {
     
   }
  });
 
 